/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import useForm from '../../utils/useForm';

const useLenderOnboardingStepTwo = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Contact Info',
        subTitle:
          'Who should we refer to borrowers in the event the borrower needs to be directed to the lender?',
        fields: [
          {
            title: 'Email',
            name: 'email',
            type: 'text',
            validation: 'email',
            required: true,
          },
          {
            title: 'Phone',
            name: 'phone',
            type: 'text',
            validation: 'phone',
            mask: '(999) 999-9999',
            required: true,
          },
        ],
      },
    ],
    []
  );

  const { formik } = useForm({
    fields,
    onSubmit,
    values,
    onlyValuesPresentInForm: true,
  });

  return { formik, fields };
};

export default useLenderOnboardingStepTwo;
